export default String.raw`
.graphical-variant-popup {
    width: 500px;
    max-width: 500px;
    min-height: 460px;

    .dialog {
        &__header {
            gap: 16px;

            &-title {
                margin-right: auto;
                @include h2-headline;
            }

            svg {
                flex-shrink: 0;
            }
        }

        &__content {
            padding: 24px 32px 0 32px;
            gap: 12px;

            p {
                @include body-2-medium;

                span {
                    @include body-2-regular;
                }
            }

            .chips-container {
                display: flex;
                flex-wrap: wrap;
                gap: 16px;
                max-height: 248px;
                overflow-y: auto;

                .chip {
                    position: relative;
                    display: flex;
                    width: 72px;
                    height: 72px;
                    justify-content: center;
                    align-items: center;
                    gap: 12px;
                    border-radius: 5px;
                    border: 1px solid #D5D5D5;
                    cursor: pointer;

                    &--color {
                        width: 40px;
                        height: 40px;
                        aspect-ratio: 1/1;
                        border-radius: 100%;
                        border: none;
                        padding: 0;

                        .multicolor {
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                            background: conic-gradient(
                                red,
                                yellow,
                                green,
                                cyan,
                                blue,
                                magenta,
                                red
                            );
                        }
                    }

                    &--default {
                        height: 40px;
                        width: auto;
                        padding: 10px 16px;
                        justify-content: center;
                        align-items: center;
                    }

                    input {
                        position: absolute;
                        opacity: 0;
                        width: 0;
                        height: 0;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    &:has(input:checked) {
                        border: 2px solid $primaryColor;
                        font-weight: 600;
                    }
                }
            }
        }

        &__actions {
            width: 100%;
            padding: 24px 32px 32px 32px;
            justify-content: center;

            button {
                width: 320px;
            }
        }
    }
}
`